import React, { forwardRef } from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import { useTheme } from 'styled-components';
import { ChevronDown } from '@styled-icons/bootstrap/ChevronDown';
export const Item = styled.div `
  position: relative;
  box-shadow: 0px 5px 16px 0px #00000026;
  border-radius: ${({ theme }) => theme.borderRadius};
  overflow: hidden;
  margin-bottom: 8px;
  width: 100%;

  ${({ preview, theme, hidden2 }) => preview &&
    !hidden2 &&
    `
    margin-top: 16px;
    overflow: visible;

    &:before,
    &:after {
      content: "";
      position: absolute;
      border-radius: ${theme.borderRadius};
      left: 50%;
      transform: translateX(-50%);
      height: 60px;
      background: ${theme.palette.grey[100]};
      box-shadow: 0px 5px 16px 0px #00000026;
    }

    &:before {
      width: 96%;
      z-index: 2;
      top: -6px;
    }
    
    &:after {
      width: 90%;
      z-index: 1;
      top: -12px;
    }
  `}

  ${({ flat }) => flat &&
    `
    box-shadow: none;
    margin-left: -16px;
    margin-bottom: 0;
  `}
`;
export const Header = styled.div `
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 12px 16px;
  display: flex;
  align-items: center;
  background: #fff;
  cursor: pointer;
  z-index: 3;

  ${({ hidden }) => hidden && `display: none;`}

  .list-icon {
    margin-right: 8px;
    width: 39px;
  }

  ${({ disabled }) => disabled &&
    `
    cursor: default;
  `}
`;
const Indicator = styled(ChevronDown) `
  position: absolute;
  color: ${({ theme }) => theme.palette.grey[300]};
  right: 16px;
  top: 50%;
  transform: scale(${({ open }) => (open ? -1 : 1)})
    translateY(${({ open }) => (open ? '50%' : '-50%')});
`;
const NavigationIcon = styled.div `
  position: absolute;
  right: 16px;
  top: 50%;
  color: ${({ theme }) => theme.palette.grey[300]};
  transform: translate(0, -50%);
`;
export const Title = styled.h4 `
  font-size: 16px !important;
  font-weight: 700 !important;
  margin-bottom: 2px !important;
  margin-top: 0;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const TextContainer = styled.div `
  width: 100%;
  margin-right: 24px;
  overflow: hidden;
  white-space: nowrap;
`;
export const Subtitle = styled.div `
  font-size: 12px;
  color: ${({ theme }) => theme.palette.grey[600]};
`;
const Fade = styled.div `
  position: absolute;
  bottom: 0;
  display: block;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.2),
    rgba(255, 255, 255, 1) 100%
  );
`;
const ListItem = forwardRef(({ title, image, subtitle, Icon, children, active, flat, disabled, preview, hideHeader, hideSubtitle, hideIndicator, navigationIcon, onClick = () => null, }, ref) => {
    const { palette } = useTheme();
    return (React.createElement(Item, { flat: flat, preview: preview, ref: ref, hidden2: hideHeader },
        React.createElement(Header, { onClick: onClick, disabled: disabled, hidden: hideHeader },
            React.createElement(Icon, { className: "list-icon", color: active ? palette.primary.main : undefined, image: image }),
            React.createElement(TextContainer, null,
                React.createElement(Title, null, title ? title : React.createElement(Skeleton, { width: 120 })),
                !hideSubtitle && (React.createElement(Subtitle, null, subtitle ? subtitle : React.createElement(Skeleton, { width: 80 })))),
            !preview && !hideIndicator && (React.createElement(React.Fragment, null, !!navigationIcon ? (React.createElement(NavigationIcon, null, navigationIcon)) : (React.createElement(Indicator, { size: 16, open: active }))))),
        children,
        !title && !subtitle && React.createElement(Fade, null)));
});
ListItem.displayName = 'ListItem';
export default ListItem;
